export default __webpack_public_path__ + "static/media/closet1-1024w.32170df3.webp";